import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LOGO_URL, SAUDE_NAV_LINKS } from '../data';

export default function SaudeNavbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goToSection = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      aria-label="Navegação principal"
      className={`absolute left-1/2 top-3 z-50 w-[min(1240px,94%)] -translate-x-1/2 rounded-2xl border border-white/10 backdrop-blur-md transition-colors duration-300 md:top-4 md:rounded-full ${
        scrolled ? 'bg-primary-600/95' : 'bg-primary-600/85'
      }`}
    >
      <div className="flex h-16 items-center justify-between px-4 md:h-20 md:pl-6 md:pr-2">
        <div className="flex shrink-0 items-center gap-3">
          <button
            type="button"
            onClick={() => navigate('/')}
            aria-label="Voltar para a página inicial"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-background-100 transition-colors hover:bg-white/10 hover:text-background-50"
          >
            <i className="ri-arrow-left-line text-lg"></i>
          </button>
          <button type="button" onClick={() => navigate('/')} className="cursor-pointer">
            <img src={LOGO_URL} alt="GetPoints" className="logo-glow h-10 w-auto md:h-11" />
          </button>
          <span className="hidden rounded-full border border-white/20 px-3 py-1 text-xs font-semibold text-background-50 sm:inline-block">
            Saúde
          </span>
        </div>

        <div className="hidden items-center gap-1 lg:flex">
          {SAUDE_NAV_LINKS.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => goToSection(link.href)}
              className="cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-background-100/75 transition-colors hover:bg-white/10 hover:text-background-50"
            >
              {link.label}
            </button>
          ))}
        </div>

        <div className="hidden items-center gap-2 lg:flex">
          <button
            type="button"
            onClick={() => navigate('/solicitar-demo')}
            className="h-10 cursor-pointer whitespace-nowrap rounded-full bg-background-50 px-5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            Fale com especialista
          </button>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((value) => !value)}
          aria-label={menuOpen ? 'Fechar menu de navegação' : 'Abrir menu de navegação'}
          aria-expanded={menuOpen}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-background-50 transition-colors hover:bg-white/10 lg:hidden"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="px-4 pb-4 pt-1 lg:hidden">
          <div className="rounded-2xl border border-white/10 bg-primary-700/80 p-2">
            {SAUDE_NAV_LINKS.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => goToSection(link.href)}
                className="w-full cursor-pointer rounded-xl px-4 py-3 text-left text-sm font-medium text-background-100/85 transition-colors hover:bg-white/10 hover:text-background-50"
              >
                {link.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => {
                setMenuOpen(false);
                navigate('/solicitar-demo');
              }}
              className="mt-2 h-11 w-full cursor-pointer whitespace-nowrap rounded-xl bg-background-50 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              Fale com especialista
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}